import React, {useEffect, useState} from 'react';
import {Link} from 'react-router-dom';
import styles from './Login.module.css';
import {Eye, EyeOff, User, Lock, Loader2} from 'lucide-react';
import {CgLock} from "react-icons/cg";
import {IoPersonCircleOutline} from "react-icons/io5";
import logo from '../../assets/logo.svg';
import logoLight from '../../assets/logo-light.svg';
import {useTheme} from "../ThemeContext/ThemeContext";
import {useNavVisibility} from '../NavVisibilityContext/NavVisibilityContext';

const Login = ({ onLogin, handleShowHeader, handleShowSettingsHeader, geoposition }) => {
    const [error, setError] = useState(false);
    const [clientId, setClientId] = useState('');
    const [password, setPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [loggingIn, setLoggingIn] = useState(false);
    const { isDarkMode } = useTheme();  // Use the useTheme hook
    const logoSrc = isDarkMode ? logoLight : logo;  // Choose logo based on theme
    const { setIsNavVisible } = useNavVisibility();

    useEffect(() => {
        handleShowHeader(false);
        handleShowSettingsHeader(false);
        setIsNavVisible(false);
    }, []);

    const handleSubmit = async (e) => {
        setLoggingIn(true);
        e.preventDefault();
        const shouldNavigate = true;
        const result = await onLogin(clientId, password, shouldNavigate);

        console.log(result);
        if (result.success === false) {
            setError(result.message);
        }
        setLoggingIn(false);
    };

    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };

    return (
        <div className={styles.container}>
            <Link to={"https://mckinneytaxservices.com"} className={styles.logoWrap}>
                <h2 className={styles.logoText}>McKinney Tax Services</h2>
                <div className={styles.logoContainer}>
                    <img src={logoSrc} alt="Logo" className={styles.logo}/>
                </div>

            </Link>

            <div className={styles.formContainer}>
                <div className={styles.formCard}>
                    <h2 className={styles.title}>Login</h2>
                    <form onSubmit={handleSubmit} className={styles.form}>
                        <div className={styles.inputWrap}>
                            <div className={styles.registerLink}>
                                <h2>If you have multiple accounts, use your client id for the account you want to login to.</h2>
                            </div>
                            <div className={styles.inputGroup}>
                                <div className={styles.inputWrapper}>
                                    <IoPersonCircleOutline className={styles.icon}/>
                                    <input
                                        className={styles.input}
                                        id="clientId"
                                        type="text"
                                        value={clientId}
                                        placeholder="Client ID"
                                        onChange={(e) => setClientId(e.target.value)}
                                        required
                                    />
                                </div>
                            </div>
                            <div className={styles.inputGroup}>

                                <div className={styles.inputWrapper}>
                                    <CgLock className={styles.icon}/>
                                    <input
                                        className={styles.input}
                                        id="password"
                                        type={showPassword ? "text" : "password"}
                                        value={password}
                                        placeholder="Password"
                                        onChange={(e) => setPassword(e.target.value)}
                                        required
                                    />
                                    <button
                                        type="button"
                                        onClick={togglePasswordVisibility}
                                        className={styles.togglePassword}
                                    >
                                        {showPassword ? (
                                            <EyeOff className={styles.icon}/>
                                        ) : (
                                             <Eye className={styles.icon}/>
                                         )}
                                    </button>
                                </div>
                                {error && (
                                    <div className="text-red-700 font-bold text-sm my-2">
                                        {error}
                                    </div>
                                )}
                            </div>
                            <div className={styles.registerLink}>
                                <Link to="/forgot-password">Forgot Password?</Link>
                            </div>
                        </div>

                        <div className={styles.buttonGroup}>
                            <div className={styles.registerLink}>
                                <span>New to McKinney Tax Services? </span>
                                <br/>
                                <Link to="/portal-request">Sign up here</Link>
                            </div>
                            <button className={styles.submitButton} type="submit">
                                {loggingIn ? (
                                    <span className={`flex flex-row justify-center items-center`}>Logging In... <Loader2 className="w-4 h-4 animate-spin"/></span>
                                ) : (
                                     <span>Login</span>

                                 )}
                            </button>
                        </div>

                    </form>

                </div>
            </div>
        </div>
    );
};

export default Login;
